export default {
    // modules
    actions: '',
    actionanddecisions: 'mdi-playlist-check',
    actionanddecisionitems: 'mdi-format-list-bulleted',
    ambienttemperatures: '',
    applications: '',
    articles: 'PhFireExtinguisher',
    assets: 'PhTreeView',
    brands: 'mdi-creative-commons',
    characteristics: '',
    classifications: '',
    climate: '',
    companies: 'mdi-office-building',
    contacts: 'mdi-contacts-outline',
    conformitymarks: 'mdi-marker-check',
    damagechances: '',
    dashboard: 'PhLayout',
    defects: 'mdi-file-document-alert',
    defectconsultations: 'mdi-help-network-outline',
    defectrepairs: 'mdi-file-document-alert',
    distributionpanels: 'mdi-light-switch-off',
    distributiondevicefunctions: 'mdi-monitor-dashboard',
    documents: 'mdi-file-document',
    documentation: 'mdi-bookshelf',
    dnvverificationregister: 'mdi-clipboard-list-outline',
    employees: 'PhAddressBook',
    emergencies: '',
    equipmentgroups: '',
    equipmentprotectionlevels: '',
    equipmentcategories: '',
    equipmenttypes: 'mdi-ticket-confirmation-outline',
    environments: '',
    explosiveatmospheres: '',
    expertises: 'mdi-school',
    fields: 'mdi-format-letter-matches',
    fieldsets: 'mdi-view-list-outline',
    forms: 'mdi-file-table-outline',
    formquestions: 'mdi-help-circle-outline',
    gasgroups: '',
    home: 'mdi-home',
    importassets: 'mdi-upload',
    importphases: 'mdi-upload',
    impactloads: '',
    intensity: '',
    inspectioninstitutes: 'mdi-office-building',
    inspectioninstitutecertifications: 'mdi-city',
    inspectioncodes: 'mdi-ab-testing',
    inspectioncertificates: 'mdi-certificate',
    inspectiondelays: '',
    inspectionclasses: '',
    inspections: 'mdi-account-hard-hat',
    inspectionsconfig: 'mdi-cog',
    iptypes: 'mdi-cable-data',
    ipindications: 'mdi-cable-data',
    linevoltage: 'mdi-flash-triangle-outline',
    locations: 'mdi-map-marker',
    markering: '',
    materials: '',
    measurements: 'mdi-ab-testing',
    notes: 'mdi-note',
    people: 'mdi-human-male-female',
    permissions: 'mdi-security',
    planner: 'PhCalendarCheck',
    platformmanagement: 'mdi-card-account-phone-outline',
    powersystems: '',
    projects: 'PhFolders',
    projectmanagement: 'PhClipboard',
    projectmanagementquestions: 'mdi-file-table-outline',
    projectmanagementtasks: 'mdi-briefcase-outline',
    profile: 'mdi-account',
    protectionkinds: '',
    protectiontypes: '',
    protectionmethods: 'mdi-shield-check-outline',
    punchlists: 'PhListChecks',
    punchlistitems: 'mdi-format-list-bulleted',
    procedures: 'mdi-progress-wrench',
    procedureresults: '',
    proceduresteps: 'mdi-debug-step-over',
    questionnaires: 'mdi-file-table-outline',
    questionnairequestions: 'mdi-help-circle-outline',
    questioncategories: 'mdi-format-list-bulleted',
    questionnaireresults: 'mdi-format-list-bulleted',
    regulations: '',
    roles: 'PhUserSwitch',
    rooms: '',
    search: 'mdi-folder-search',
    settings: 'PhSlidersHorizontal',
    stof: '',
    substances: '',
    standarddeviations: 'mdi-file-document-alert',
    tags: 'mdi-tag',
    tagnumbers: 'mdi-map-marker',
    templates: 'mdi-file-document-edit',
    temperatureclasses: '',
    tokens: 'mdi-account-key',
    translations: 'mdi-translate',
    triggers: '',
    typesandsubtypes: 'mdi-file-document-edit',
    usagefrequency: '',
    users: 'mdi-account',
    vibrations: '',
    water: '',
    workflows: 'mdi-transit-connection-variant',
    workequipmentgroups: '',
}